export default import.meta.ROLLUP_FILE_URL_swgdHcDAs3h9nBqmkgXKaQ